import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useAiReviewFilterBarStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: designTokens.spacing[3],
  },
  filters: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: designTokens.spacing[2],
  },
  acceptAll: {
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    marginLeft: "auto",
  },
});
